export class ArticleFamilyDto {
    id!: number;
    name!: string;
    externalReference?: string;
    parentArticleFamilyId?: number | null;
}
